import { Amplify, API, graphqlOperation } from 'aws-amplify';

import awsmobile from './../aws-exports';
import Cookies from 'js-cookie';

Amplify.configure(awsmobile);
API.configure(awsmobile);

const customPost = (API, { query, variables, limitless, isPublic = false }) => {
  const { accessToken } = JSON.parse(Cookies.get('sdm-auth') || '{}');

  return API.post('authendpoint', '/query', {
    body: { query, variables, accessToken, limitless, isPublic },
  });
};

const lambdaPost = (API, { apiName, path, body }) => {
  return API.post(apiName, path, {
    body,
  });
};

export default {
  API: {
    lambdaPost: (apiName, path, body) =>
      lambdaPost(API, { apiName, path, body }),
    post: (query, variables, limitless, isPublic = false) =>
      customPost(API, { query, variables, limitless, isPublic }),
  },
  standardAPI: API,
  graphql: {
    graphqlOperation,
  },
};
